import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-12 md:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl mb-6 md:mb-8">
            <Icon name="MessageSquare" size={32} color="var(--color-primary)" className="md:w-10 md:h-10 lg:w-12 lg:h-12" />
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-foreground mb-4 md:mb-6">
            Let's Build Something Extraordinary Together
          </h1>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body leading-relaxed">
            Whether you're ready to start your project or just exploring possibilities, we're here to help. 
            Our team of experts is committed to understanding your vision and delivering solutions that drive real business results.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;